// Endpoint paths, query params and enums for the App Registry (Channels/Apps) feature.
// Base path: /hacloud/api/v2/app-registry (no generated SDK client yet - called via apiClient.callApi).
import SessionStorage from '@vantiva-sa/homesight_humaui/Utilities/SessionStorage';
import { AppStorageKeys } from '@vantiva-sa/homesight_humaui/Utilities/Constants';

export const APP_REGISTRY_API_PATHS = {
  VIEW: '/hacloud/api/v2/app-registry/view',
  USER_OVERRIDE: '/hacloud/api/v2/app-registry/overrides/user/{useruuid}/{appuuid}',
  // Bulk variant - no {appuuid} in the path, body is a JSON array of { appuuid, enabled }.
  USER_OVERRIDE_BULK: '/hacloud/api/v2/app-registry/overrides/user/{useruuid}',
};

export const APP_REGISTRY_LEVEL = {
  USER: 'user',
};

export const APP_REGISTRY_VIEW_MODE = {
  ADMIN: 'admin',
};

export const APP_REGISTRY_LAUNCHER_PLACEMENT = {
  CONTENT: 'content',
  APPS: 'apps',
};

export const APP_REGISTRY_QUERY_KEY = 'appRegistry';

// App Registry currently points at a local test host (V2_API_BASE_URL) instead of the main API base path.
export const getAppRegistryBaseUrl = () =>
  (SessionStorage.get(AppStorageKeys.envVars)?.V2_API_BASE_URL || '').replace(/\/+$/, '');
